const asyncActionType = type => ({
    pending: `${type}_PENDING`,
    success: `${type}_SUCCESS`,
    error: `${type}_ERROR`
});

export const GET_ACTIVITY_LIST = asyncActionType('GET_ACTIVITY_LIST');
export const DELETE_ACTIVITY = asyncActionType('DELETE_ACTIVITY');
export const DELETE_ALL_ACTIVITIES = asyncActionType('DELETE_ALL_ACTIVITIES');